module.exports = __webpack_public_path__ + "ajax-loader.b4e5dbad32fe3ddf5496.gif";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/material/images/ajax-loader.gif
// module id = ../../../../syncfusion-javascript/Content/ej/web/material/images/ajax-loader.gif
// module chunks = 2